/*
  PDP price / discount engine (moved out of snippets/product-price-js.liquid so the
  browser can cache it instead of re-downloading ~28 KB of inline script per page).
  Loaded with `async`; it starts as soon as it has loaded and falls back to
  DOMContentLoaded when #pdp-price-row is not in the DOM yet.
*/

    (function () {
        "use strict";

        /* Runs once per page even if the price snippet is rendered more than once
           (e.g. inside a quick-view drawer). */
        if (window.__maPdpPriceEngineLoaded) return;
        window.__maPdpPriceEngineLoaded = true;

        /* Theme settings and the few cart fields this script reads are rendered by
           snippets/product-price-js.liquid as a JSON block; nothing else is templated. */
        const configEl = document.querySelector('[data-pdp-price-config]');
        const config = configEl ? JSON.parse(configEl.textContent) : {};
        config.bogo = config.bogo || {};
        config.bogoGift = config.bogoGift || {};
        config.cart = config.cart || { discount_applications: [], discount_codes: [], items: [] };
        window.cartData = config.cart;

        /*====================================================
        CONFIG
        ====================================================*/
window.SHOPIFY_NOW = config.now;

        /* Single live Apps Script endpoint used by the PDP discount service. */
        const APPS_SCRIPT_URL =
            "https://script.google.com/macros/s/AKfycbz-2kNwCgc-s6ncoheNV-gQtLAAxD5OIVAeS3ovsQ3lR39OVk9QCY8g-h0wXwZtdAI2/exec";

        /* Version the response cache so any old one-hour responses from the
           previous build can never be reused by this build. */
        const STORAGE_KEY = "pdp_discount_cache_v4";
        const CODE_STORAGE_KEY = "pdp_discount_code";
        const AUTOMATIC_CACHE_DURATION = 10 * 60 * 1000;
        const URL_DISCOUNT_CACHE_DURATION = 60 * 60 * 1000;
        const CODE_DURATION = 60 * 60 * 1000;
        const REFRESH_INTERVAL = 60 * 1000;
        const DISCOUNT_REQUEST_TIMEOUT = 4500;

        const inFlightDiscountRequests = new Map();

        const FIRST_TIME_DISCOUNT_TITLE = config.firstTimeDiscountTitle;

    const BOGO_ENABLED = config.bogo.enabled;
    const BOGO_TEXT = config.bogo.text;
    const BOGO_START = config.bogo.start;
    const BOGO_END = config.bogo.end;

    const BOGO_GIFT_ENABLED = config.bogoGift.enabled;
    const BOGO_GIFT_TEXT = config.bogoGift.text;
    const BOGO_GIFT_START = config.bogoGift.start;
    const BOGO_GIFT_END = config.bogoGift.end;

    const MONEY_FORMAT = config.moneyFormat;

    /* Theme-controlled sale (Theme settings → "PDP Sale"), resolved for this product
       by snippets/ma-sale-rule.liquid: { enabled, type, value, message, start, end }.
       While it applies (see themeSaleApplies) the price row is computed from it and
       no discount lookup is made, so the sale never depends on the Apps Script
       service. Everything else below is the lookup-driven engine as before. */
    const THEME_SALE = config.sale || {};


    /*====================================================
    MONEY
    ====================================================*/

    function formatMoney(cents) {

        if (window.Shopify && Shopify.formatMoney) {
            return Shopify.formatMoney(cents, MONEY_FORMAT);
        }

        /* Shopify.formatMoney is not loaded on this theme, so format here, following the
           store's money format (Settings → Store currency), like Liquid's `money` filter:
           "${{amount}}" gives "$1,264.00" (3 Nov 2026: was "$1264.00", no thousands comma). */
        const format = MONEY_FORMAT || "${{amount}}";
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const amount = (Number(cents) || 0) / 100;

        function group(decimals, thousands, point) {
            const parts = amount.toFixed(decimals).split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return parts[1] ? parts[0] + point + parts[1] : parts[0];
        }

        let value;
        switch (match ? match[1] : "amount") {
            case "amount_no_decimals": value = group(0, ",", "."); break;
            case "amount_with_comma_separator": value = group(2, ".", ","); break;
            case "amount_no_decimals_with_comma_separator": value = group(0, ".", ","); break;
            case "amount_with_apostrophe_separator": value = group(2, "'", "."); break;
            default: value = group(2, ",", ".");
        }

        return match ? format.replace(match[0], value) : "$" + value;

    }





    /*====================================================
    DISCOUNT CODE + CACHE
    ====================================================*/

    function readDiscountFromURL() {

        try {

            const params = new URLSearchParams(window.location.search);

            return (
                params.get("discount") ||
                params.get("discount_code") ||
                ""
            ).trim();

        } catch (e) {

            return "";

        }

    }


    function saveDiscountCode(code) {

        code = String(code || "").trim();

        if (!code) {
            return;
        }

        localStorage.setItem(
            CODE_STORAGE_KEY,
            JSON.stringify({
                code: code,
                expiry: Date.now() + CODE_DURATION
            })
        );

    }


    function readStoredDiscountCode(key) {

        try {

            const saved = JSON.parse(
                localStorage.getItem(key)
            );

            if (!saved) {
                return "";
            }

            if (Date.now() >= Number(saved.expiry || 0)) {
                localStorage.removeItem(key);
                return "";
            }

            return String(saved.code || "").trim();

        } catch (e) {

            return "";

        }

    }


    function getDiscountCode() {

        /* A code on the current URL always wins and refreshes the PDP copy. */
        const urlCode = readDiscountFromURL();

        if (urlCode) {
            saveDiscountCode(urlCode);
            return urlCode;
        }

        /* Current key first, followed by keys used by the earlier discount
           implementations so existing customer sessions keep working. */
        const keys = [
            CODE_STORAGE_KEY,
            "discount_code",
            "shop_discount_code"
        ];

        for (const key of keys) {

            const code = readStoredDiscountCode(key);

            if (code) {
                if (key !== CODE_STORAGE_KEY) {
                    saveDiscountCode(code);
                }
                return code;
            }

        }

        return "";

    }


    function discountCacheKey(variantId, code) {

        return STORAGE_KEY + "_" +
            String(variantId || "0") + "_" +
            encodeURIComponent(String(code || "none").toUpperCase());

    }


    function getCachedDiscount(variantId, code) {

        try {

            const key = discountCacheKey(variantId, code);
            const cached = JSON.parse(localStorage.getItem(key));

            if (!cached) {
                return null;
            }

            if (Date.now() > Number(cached.expiry || 0)) {
                localStorage.removeItem(key);
                return null;
            }

            return cached.response || null;

        } catch (e) {

            return null;

        }

    }


    function getDiscountCacheDuration(code, response) {

        const explicitCode = String(code || "").trim();
        const data = response && response.data && typeof response.data === "object"
            ? response.data
            : {};

        /* Automatic / BOGO pricing can change independently of the URL code,
           so never hold an automatic result longer than ten minutes. */
        const isAutomatic = Boolean(
            data.automaticDiscount ||
            data.bogo ||
            data.bogoGift
        );

        if (isAutomatic) {
            return AUTOMATIC_CACHE_DURATION;
        }

        /* An explicit discount carried into the PDP (for example
           ?discount=MADEFORYOU) is kept for one hour. The code itself is also
           stored for one hour in CODE_STORAGE_KEY, so it survives navigation. */
        if (explicitCode) {
            return URL_DISCOUNT_CACHE_DURATION;
        }

        /* No-code responses are automatic checks and are refreshed after
           ten minutes so current promotions stay up to date. */
        return AUTOMATIC_CACHE_DURATION;

    }


    function saveCachedDiscount(variantId, code, response) {

        try {

            const cacheDuration = getDiscountCacheDuration(code, response);

            localStorage.setItem(
                discountCacheKey(variantId, code),
                JSON.stringify({
                    response: response,
                    savedAt: Date.now(),
                    cacheDuration: cacheDuration,
                    expiry: Date.now() + cacheDuration
                })
            );

        } catch (e) {
            /* localStorage can be unavailable in strict/privacy contexts. */
        }

    }


    /*====================================================
    FETCH DISCOUNT
    ====================================================*/

    function normalizeDiscountResponse(raw, requestedCode) {

        if (!raw || typeof raw !== "object") {
            return null;
        }

        /* Current/July Apps Script response contract. */
        if (raw.success === true && raw.data && typeof raw.data === "object") {
            return raw;
        }

        /* Some earlier deployments returned the discount fields at the top
           level. Normalize them into the response shape used by applyDiscount. */
        if (raw.success === true) {
            const percentage = Number(
                raw.effectivePercentage != null
                    ? raw.effectivePercentage
                    : raw.percentage || 0
            );

            return {
                success: true,
                data: {
                    found: raw.found !== false,
                    subtotal: raw.subtotal,
                    total: raw.total,
                    discountAmount: raw.discountAmount,
                    percentage: percentage,
                    effectivePercentage: percentage,
                    discountCode: raw.discountCode || requestedCode || "",
                    discountApplicable: Boolean(
                        raw.discountApplicable != null
                            ? raw.discountApplicable
                            : raw.firstTime
                    ),
                    automaticDiscount: Boolean(raw.automaticDiscount),
                    bogo: Boolean(raw.bogo),
                    bogoGift: Boolean(raw.bogoGift)
                }
            };
        }

        /* The ghost-cart helper bundled with the theme returns a raw summary
           rather than { success, data }. Supporting it here makes the storefront
           resilient if that Apps Script deployment is used again. */
        if (raw.error === false) {
            const applications = Array.isArray(raw.discountApplications)
                ? raw.discountApplications
                : [];
            const codes = Array.isArray(raw.discountCodes)
                ? raw.discountCodes
                : [];
            const requestedUpper = String(requestedCode || "").trim().toUpperCase();
            const matchingCode = codes.find(function (item) {
                return item && String(item.code || "").trim().toUpperCase() === requestedUpper;
            });
            const applicationText = applications.map(function (item) {
                return String(item && item.titleOrCode || "");
            }).join(" ").toUpperCase();
            const isBogo =
                applicationText.indexOf("BOGO") !== -1 ||
                applicationText.indexOf("BUY ONE") !== -1 ||
                applicationText.indexOf("GET ONE") !== -1;
            const isAutomatic = applications.some(function (item) {
                return item && (
                    item.applicationType === "automatic" ||
                    item.applicationType === "custom"
                );
            });
            const percentage = Number(raw.effectivePercentage || 0);

            return {
                success: true,
                data: {
                    found: true,
                    subtotal: raw.subtotal,
                    total: raw.total,
                    discountAmount: raw.totalDiscountAmount,
                    percentage: percentage,
                    effectivePercentage: percentage,
                    discountCode: requestedCode || "",
                    discountApplicable: Boolean(matchingCode && matchingCode.applicable),
                    automaticDiscount: isAutomatic,
                    bogo: isBogo
                }
            };
        }

        return null;
    }


    async function requestDiscountFromEndpoint(payload) {

        const controller = typeof AbortController !== "undefined"
            ? new AbortController()
            : null;
        const timeoutId = controller
            ? setTimeout(function () { controller.abort(); }, DISCOUNT_REQUEST_TIMEOUT)
            : null;

        const options = {
            method: "POST",
            cache: "no-store",
            redirect: "follow",
            body: new URLSearchParams({
                variantId: "gid://shopify/ProductVariant/" + payload.variantId,
                discountCode: payload.discountCode || ""
            })
        };

        if (controller) {
            options.signal = controller.signal;
        }

        try {
            const response = await fetch(APPS_SCRIPT_URL, options);

            if (!response.ok) {
                throw new Error("Discount API request failed: " + response.status);
            }

            return await response.json();
        } finally {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        }
    }


    async function callDiscountApi(variantId, productId, code) {

        const payload = {
            variantId: Number(variantId),
            productId: Number(productId || 0),
            discountCode: code || ""
        };

        const raw = await requestDiscountFromEndpoint(payload);
        const normalized = normalizeDiscountResponse(raw, code);

        if (!normalized) {
            throw new Error("Discount API returned an unsupported response");
        }

        return normalized;
    }


    async function fetchDiscount(variantId) {

        let code = getDiscountCode();

        /* Cart data remains a fallback for discounts already applied to cart. Only an
           entered code is remembered for the hour; an automatic discount's title is not. */
        if (!code) {
            code = getCartDiscount();
            const enteredCode = getCartDiscountCode();
            if (enteredCode) {
                saveDiscountCode(enteredCode);
            }
        }

        const currentVariant = getVariantData();
        const productId = currentVariant ? currentVariant.productId : 0;
        const cacheKey = discountCacheKey(variantId, code);

        /* Cache lifetime is response-aware:
           - active automatic / BOGO result: 10 minutes
           - explicit URL/stored discount code: 1 hour
           - no-code response: 10 minutes
           Once the relevant TTL expires, the next update calls Apps Script again. */
        const cached = getCachedDiscount(variantId, code);
        if (cached) {
            return cached;
        }

        /* Variant events, section morphs and the refresh timer can fire together.
           Share one request for the same variant/code instead of creating several
           ghost-cart calculations at the same time. */
        if (inFlightDiscountRequests.has(cacheKey)) {
            return inFlightDiscountRequests.get(cacheKey);
        }

        const request = callDiscountApi(variantId, productId, code)
            .then(function (result) {
                saveCachedDiscount(variantId, code, result);
                return result;
            })
            .finally(function () {
                inFlightDiscountRequests.delete(cacheKey);
            });

        inFlightDiscountRequests.set(cacheKey, request);

        return request;
    }

    /*====================================================
    CART DISCOUNT
    ====================================================*/

    /* Only an entered code counts as a code. cart.discount_applications also lists
       automatic discounts (and Liquid leaves `type` blank for app discounts), so the
       titles there must not steer the price display or be stored as if a customer
       had typed them. cart.discount_codes lists entered codes only. */
    function getCartDiscountCode() {

        if (!window.cartData) {
            return "";
        }

        const cart = window.cartData;

        if (Array.isArray(cart.discount_codes)) {
            for (const entry of cart.discount_codes) {
                if (entry && entry.code && entry.applicable !== false) {
                    return entry.code;
                }
            }
        }

        if (cart.discount_applications && cart.discount_applications.length) {
            for (const application of cart.discount_applications) {
                if (
                    application &&
                    application.title &&
                    application.type === "discount_code"
                ) {
                    return application.title;
                }
            }
        }

        if (cart.items) {
            for (const item of cart.items) {
                if (item.properties && item.properties.discount_code) {
                    return item.properties.discount_code;
                }
            }
        }

        return "";

    }


    function getCartDiscount() {

        if (!window.cartData) {
            return "";
        }

        const cart = window.cartData;


        /* Applied discounts */

        if (
            cart.discount_applications &&
            cart.discount_applications.length
        ) {

            return cart.discount_applications[0].title;

        }


        /* Item properties */

        if (cart.items) {

            for (const item of cart.items) {

                if (
                    item.properties &&
                    item.properties.discount_code
                ) {

                    return item.properties.discount_code;

                }

            }

        }


        return "";

    }




    /*====================================================
    DATE HELPERS
    ====================================================*/

    function parseDate(value) {

        if (!value) {
            return null;
        }

        const date = new Date(value);

        return isNaN(date.getTime()) ? null : date;

    }

/*====================================================
DATE HELPERS
====================================================*/

function parseStoreDate(value) {

    if (!value) {
        return null;
    }

    const offset = getStoreOffset();

    const date = new Date(
        value + offset
    );

    return isNaN(date.getTime())
        ? null
        : date;

}


function getStoreOffset() {

    const match = window.SHOPIFY_NOW.match(
        /([+-]\d{4})$/
    );

    return match ? match[1] : "+0000";

}


/*====================================================
STORE TIME CLOCK
====================================================*/

const SHOPIFY_START_TIME = new Date(
    window.SHOPIFY_NOW
).getTime();

const BROWSER_START_TIME = Date.now();


function getStoreNow() {

    const elapsed =
        Date.now() - BROWSER_START_TIME;


    return new Date(
        SHOPIFY_START_TIME + elapsed
    );

}


function campaignActive(
    enabled,
    start,
    end
) {

    if (!enabled) {
        return false;
    }


    const now = getStoreNow();

    const startDate = parseStoreDate(start);
    const endDate = parseStoreDate(end);


    if (startDate && now < startDate) {
        return false;
    }


    if (endDate && now > endDate) {
        return false;
    }


    return true;

}
    /*====================================================
    DOM HELPERS
    ====================================================*/

    function getPriceRow() {
        return document.getElementById("pdp-price-row");
    }


    function getVariantData() {

        const row = getPriceRow();

        if (!row) {
            return null;
        }

        return {
            variantId: Number(row.dataset.variantId),
            price: Number(row.dataset.variantPrice),
            productId: Number(row.dataset.productId)
        };

    }


    function getUI() {

        const display = document.getElementById("pdp-price-display");

        return {
            display,
            price: display ? display.querySelector("[data-product-price]") : null,
            tag: document.getElementById("pdp-discount-tag"),
            compare: document.getElementById("pdp-compare-price"),
            priceOff: document.getElementById("pdp-price-off")
        };

    }


    /*====================================================
    UI HELPERS
    ====================================================*/

    function hideNativeSale(ui) {

        if (ui.compare) {
            ui.compare.style.display = "none";
        }

        if (ui.priceOff) {
            ui.priceOff.style.display = "none";
        }

    }


    function showNativeSale(ui) {

        if (ui.compare) {
            ui.compare.style.display = "";
        }

        if (ui.priceOff) {
            ui.priceOff.style.display = "";
        }

    }


    function clearBadge(tag) {

        if (!tag) {
            return;
        }

        tag.className = "pdp-discount-tag";
        tag.innerHTML = "";
        tag.style.display = "none";

    }


    function resetPrice(price) {

        const ui = getUI();

        clearBadge(ui.tag);

        showNativeSale(ui);

        if (ui.price) {
            ui.price.innerHTML = formatMoney(price);
        }

    }


    /*====================================================
    BADGE
    ====================================================*/

    function showBadge(text, className) {

        const ui = getUI();

        if (!ui.tag) {
            return;
        }

        clearBadge(ui.tag);

        ui.tag.innerHTML = text;
        ui.tag.style.display = "inline-block";

        if (className) {
            ui.tag.classList.add(className);
        }

    }


    /*====================================================
    PRICE
    ====================================================*/

    function showDiscountPrice(
        price,
        percentage,
        firstTime
    ) {

        const discounted = Math.round(
            price * (1 - (percentage / 100))
        );

        showSalePrice(price, discounted, firstTime);

    }


    /* Writes the sale markup (original struck through, sale price) into the row.
       The same markup is rendered server-side by product-price.liquid for the
       theme-controlled sale; ma-pdp-handoff.js, ma-effects.js (sticky bar) and
       pdp-mobile-redesign.js (purchase card) all read these two class names. */
    function showSalePrice(
        price,
        discounted,
        firstTime
    ) {

        const ui = getUI();

        if (!ui.price) {
            return;
        }


        hideNativeSale(ui);


        ui.price.innerHTML =
            `
<span class="price-wrapper ${firstTime ? 'first-time-discount' : ''}">
<span class="pdp-original-price">
${formatMoney(price)}
</span>
<span class="pdp-final-price">
${formatMoney(discounted)}
</span>
</span>
`;

    }



    function showNormalPrice(price) {

        const ui = getUI();

        clearBadge(ui.tag);

        showNativeSale(ui);


        if (ui.price) {
            ui.price.innerHTML = formatMoney(price);
        }

    }
    /*====================================================
    APPLY DISCOUNT
    ====================================================*/

    function applyDiscount(apiData, variant) {

        if (!variant) {
            return;
        }

        const price = variant.price;


        /* BOGO GIFT */

        if (campaignActive(
            BOGO_GIFT_ENABLED,
            BOGO_GIFT_START,
            BOGO_GIFT_END
        )) {

            showNormalPrice(price);

            showBadge(
                BOGO_GIFT_TEXT,
                "pdp-bogo-gift-tag"
            );

            return;

        }


        /* SIMPLE BOGO */

        if (campaignActive(
            BOGO_ENABLED,
            BOGO_START,
            BOGO_END
        )) {

            showNormalPrice(price);

            showBadge(
                BOGO_TEXT,
                "pdp-simple-bogo-tag"
            );

            return;

        }


        /* NO API DATA */

        if (
            !apiData ||
            !apiData.success ||
            !apiData.data ||
            !apiData.data.found
        ) {

            resetPrice(price);

            return;

        }


        const data = apiData.data;


        /* API BOGO */

        if (data.bogo) {

            showNormalPrice(price);

            showBadge(
                BOGO_TEXT,
                "pdp-simple-bogo-tag"
            );

            return;

        }


        const percentage = Number(
            data.effectivePercentage || 0
        );


        if (!percentage) {

            resetPrice(price);

            return;

        }


        /* FIRST TIME DISCOUNT */

        const isFirstTime =
            data.discountApplicable &&
            data.discountCode &&
            String(data.discountCode).toUpperCase() ===
            String(FIRST_TIME_DISCOUNT_TITLE || "").toUpperCase();


        if (isFirstTime) {

            showDiscountPrice(
                price,
                percentage,
                true
            );

            showBadge(
                "Get " + Math.round(percentage) + "% Off Today", /* was "Enjoy …" (9 Oct 2026) */
                "pdp-discount-tag-styles"
            );

            return;

        }


        /* NORMAL DISCOUNT */

        showDiscountPrice(
            price,
            percentage,
            false
        );


        showBadge(
            "LIMITED TIME: " +
            Math.round(percentage) +
            "% Off"
        );

    }


    function publishPriceUpdated(variant) {

        const detail = {
            variantId: variant ? variant.variantId : null
        };

        requestAnimationFrame(function () {
            document.dispatchEvent(
                new CustomEvent("ma:pdp-price-updated", { detail: detail })
            );
        });

    }


    /*====================================================
    THEME-CONTROLLED SALE
    ====================================================*/

    function bogoCampaignActive() {
        return campaignActive(BOGO_GIFT_ENABLED, BOGO_GIFT_START, BOGO_GIFT_END) ||
               campaignActive(BOGO_ENABLED, BOGO_START, BOGO_END);
    }

    /* The theme sale owns the price row when: the setting resolved to "on" for this
       product (enabled, dates and collections, see the snippet), the dates still hold
       on the store clock, no BOGO campaign is running (they take precedence, exactly
       as in applyDiscount), and no discount code is in play. A code keeps the
       code-aware lookup, so an influencer or first-order code still shows its own
       result. */
    /* The sale is on for this product and in force now (dates on the store clock,
       no BOGO campaign). Used as the safety net when a lookup fails. */
    function themeSaleAvailable() {
        if (!THEME_SALE.enabled) return false;
        if (!campaignActive(true, THEME_SALE.start, THEME_SALE.end)) return false;
        if (bogoCampaignActive()) return false;
        return true;
    }

    function themeSaleApplies() {
        if (!themeSaleAvailable()) return false;
        if (getDiscountCode() || getCartDiscountCode()) return false;
        return true;
    }

    /* Same arithmetic as snippets/ma-sale-rule.liquid: half up to the cent, never
       below zero. */
    /* Tiered type (16 Oct 2026): "from_cents:off:kind," from the snippet; kind "a" = amount off
       (off in cents), kind "p" = percent off (off in hundredths of a percent, 10% = 1000; since
       2 Nov 2026, the cart rewards tracker's encoding). A pair without a kind is the older amount
       form. A variant shows the tier its own price reaches; below the first tier it shows the
       regular price. */
    const THEME_SALE_TIERS = String(THEME_SALE.tiers || "")
        .split(",")
        .map(function (pair) {
            const parts = pair.split(":");
            return { from: Number(parts[0]) || 0, off: Number(parts[1]) || 0, kind: parts[2] === "p" ? "p" : "a" };
        })
        .filter(function (tier) { return tier.from > 0 && tier.off > 0; })
        .sort(function (a, b) { return a.from - b.from; });
    /* "10" or "12.5" from hundredths of a percent. */
    function percentShort(hundredths) {
        return String(Math.round(hundredths) / 100);
    }
    function themeSaleTier(price) {
        let hit = null;
        for (const tier of THEME_SALE_TIERS) {
            if (tier.from <= price) hit = tier;
        }
        return hit;
    }
    function moneyShort(cents) {
        return formatMoney(cents).replace(/\.00(?=\D*$)/, ""); // "$100.00" -> "$100", like money_without_trailing_zeros
    }
    function themeSalePrice(price) {
        if (THEME_SALE.type === "tiered") {
            const tier = themeSaleTier(price);
            if (!tier) return price;
            if (tier.kind === "p") return Math.max(0, Math.round(price * (10000 - tier.off) / 10000)); // same as the snippet
            return Math.max(0, price - tier.off);
        }
        const value = Number(THEME_SALE.value) || 0;
        if (THEME_SALE.type === "amount") {
            return Math.max(0, price - Math.round(value * 100));
        }
        return Math.max(0, Math.round(price * (100 - value) / 100));
    }
    function themeSaleMessage(price) {
        if (THEME_SALE.type !== "tiered") return THEME_SALE.message || "";
        const tier = themeSaleTier(price);
        if (!tier) return "";
        const amountOff = price - themeSalePrice(price); // what this tier takes off this variant, in cents
        const max = THEME_SALE_TIERS.filter(function (t) { return t.kind === tier.kind; })
            .reduce(function (m, t) { return Math.max(m, t.off); }, 0);
        const maxLabel = tier.kind === "p" ? percentShort(max) + "%" : moneyShort(max);
        const percent = tier.kind === "p" ? percentShort(tier.off) : String(price > 0 ? Math.round(amountOff * 100 / price) : 0);
        const template = String(THEME_SALE.template || "").trim() || (tier.kind === "p" ? "LIMITED TIME: {percent}% Off" : "LIMITED TIME: {amount} Off");
        return template
            .replace(/\{amount\}/g, moneyShort(amountOff))
            .replace(/\{max\}/g, maxLabel)
            .replace(/\{from\}/g, moneyShort(tier.from))
            .replace(/\{percent\}/g, percent);
    }
    function applyThemeSale(variant) {
        const discounted = themeSalePrice(variant.price);
        if (discounted >= variant.price) {
            resetPrice(variant.price); // tiered: this variant is below the first tier
            return;
        }
        showSalePrice(variant.price, discounted, false);
        showBadge("");
        const tag = document.getElementById("pdp-discount-tag");
        if (tag) {
            tag.textContent = themeSaleMessage(variant.price); // plain text, like the server render
        }
    }


    /*====================================================
    UPDATE PRICE
    ====================================================*/

    /* The last response the API gave on this page. When the customer moves to a
       variant whose discount has not been fetched yet, that response is applied
       to the new variant's price immediately (the automatic discount is the same
       percentage for every variant of a piece), so the row never falls back to
       the undiscounted price for the one to two seconds the request takes. The
       real response then confirms it, or corrects it in the rare case it differs. */
    let lastKnownDiscount = null;

    function hasCachedDiscount(variantId) {
        const code = getDiscountCode() || getCartDiscount() || "";
        return Boolean(getCachedDiscount(variantId, code));
    }

    async function updatePrice() {

        const variant = getVariantData();

        if (!variant || !variant.variantId) {
            return;
        }

        const requestedVariantId = variant.variantId;

        /* Theme-controlled sale: computed locally, no request. */
        if (themeSaleApplies()) {
            applyThemeSale(variant);
            publishPriceUpdated(variant);
            return;
        }

        if (lastKnownDiscount && !hasCachedDiscount(requestedVariantId)) {
            applyDiscount(lastKnownDiscount, variant);
            publishPriceUpdated(variant);
        }

        try {

            const result = await fetchDiscount(requestedVariantId);

            lastKnownDiscount = result;

            /* Ignore a slow response for a variant the customer has already
               changed away from. */
            const currentVariant = getVariantData();

            if (
                !currentVariant ||
                currentVariant.variantId !== requestedVariantId
            ) {
                return;
            }

            applyDiscount(result, currentVariant);
            publishPriceUpdated(currentVariant);

        } catch (e) {

            const currentVariant = getVariantData();

            if (
                currentVariant &&
                currentVariant.variantId === requestedVariantId
            ) {
                /* A failed lookup must never erase a sale the settings vouch for. */
                if (themeSaleAvailable()) {
                    applyThemeSale(currentVariant);
                } else {
                    resetPrice(currentVariant.price);
                }
                publishPriceUpdated(currentVariant);
            }

        }

    }


    /*====================================================
    VARIANT EVENTS
    ====================================================*/

    let updateTimer;


    function scheduleUpdate() {

        clearTimeout(updateTimer);

        updateTimer = setTimeout(
            updatePrice,
            40
        );

    }


    function attachVariantEvents() {

        /*
          theme:section:update fires AFTER the section HTML is morphed,
          so the DOM is final and our price update won't be overwritten.
        */
        window.addEventListener(
            "theme:section:update",
            scheduleUpdate
        );


        /*
          theme:variant:change fires BEFORE the morph — use it only
          to sync the data-attributes so getVariantData() reads the
          correct variant price when scheduleUpdate runs later.
        */
        document.addEventListener(
            "theme:variant:change",
            function (event) {

                var variant = event.detail && event.detail.variant;

                if (variant) {
                    var row = getPriceRow();
                    if (row) {
                        row.dataset.variantId = variant.id;
                        row.dataset.variantPrice = variant.price;
                    }

                    /* Start the discount lookup immediately. When the redesigned
                       Variant options block is active we intentionally do NOT morph
                       the whole product section, so schedule the price refresh from
                       this event as well. The in-flight request is reused. */
                    if (!themeSaleApplies()) {
                        fetchDiscount(Number(variant.id)).catch(function () {});
                    }
                    scheduleUpdate();
                }

            }
        );

    }
    /*====================================================
    OBSERVE PRICE ROW
    ====================================================*/

    function observePriceRow() {

        const row = getPriceRow();

        if (!row) {
            return;
        }


        new MutationObserver(function (mutations) {

            for (const mutation of mutations) {

                if (mutation.type === "attributes") {

                    scheduleUpdate();

                    break;

                }

            }

        }).observe(row, {
            attributes: true,
            attributeFilter: [
                "data-variant-id",
                "data-variant-price"
            ]
        });

    }


    /*====================================================
    INIT
    ====================================================*/

    function init() {

        /* Remove obsolete discount-response caches from older builds so a
           previously stored one-hour result cannot mask a fresh API response. */
        try {
            const keysToRemove = [];
            for (let i = 0; i < localStorage.length; i += 1) {
                const key = localStorage.key(i);
                if (!key) continue;

                if (
                    key === "pdp_discount_cache" ||
                    (key.indexOf("pdp_discount_cache_") === 0 &&
                     key.indexOf(STORAGE_KEY + "_") !== 0)
                ) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach(function (key) {
                localStorage.removeItem(key);
            });
        } catch (e) {}

        attachVariantEvents();

        observePriceRow();

        updatePrice();

        /* Check freshness periodically. Cached responses are returned without an
           API call. Automatic pricing expires after 10 minutes; an explicit
           discount-code result can remain cached for up to 1 hour. */
        setInterval(updatePrice, REFRESH_INTERVAL);

        window.addEventListener("focus", scheduleUpdate);

        document.addEventListener("visibilitychange", function () {
            if (!document.hidden) {
                scheduleUpdate();
            }
        });

        window.addEventListener("storage", function (event) {
            if (
                event.key === CODE_STORAGE_KEY ||
                event.key === "discount_code" ||
                event.key === "shop_discount_code" ||
                event.key === "pdp_discount"
            ) {
                scheduleUpdate();
            }
        });

    }


    /* product-price-js is rendered after #pdp-price-row, so start immediately
       instead of waiting for the entire document/images to finish parsing.
       Keep a DOMContentLoaded fallback for unusual section render contexts. */
    if (getPriceRow()) {
        init();
    } else if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init, { once: true });
    } else {
        init();
    }

}) ();

